import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { UserRole } from '../models/general.models';
import RouteAuthorizer from './components/RouteAuthorizer';
import { AppRoutes } from './routes';
var CheckoutPage = React.lazy(function () { return import('../pages/checkout/checkout.page'); });
var checkoutRedirectPages = [
    {
        userRole: UserRole.Anonymous,
        page: AppRoutes.Intro,
    },
    {
        userRole: UserRole.NoCountryUser,
        page: AppRoutes.Intro,
    },
    {
        userRole: UserRole.PartialUser,
        page: AppRoutes.JoinFamily,
    },
];
var checkoutRoutes = [
    {
        path: AppRoutes.CheckoutPage,
        element: (_jsx(RouteAuthorizer, { userRoles: [
                UserRole.UserPaymentNeeded,
                UserRole.PlanPendingUser,
                UserRole.CompleteUser,
            ], redirectPages: checkoutRedirectPages, children: _jsx(CheckoutPage, {}) })),
    },
];
export default checkoutRoutes;
